import { useEffect, useState } from 'react'
import { UserJobStatus, useCafJobStatus } from '../../../../../modules/apis/student/lesson'
import { n_ai_analysis } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'

const useJobAnalysisPopup = () => {
  const { t } = useTranslation()
  const [info, setInfo] = useState({
    title: '',
    link: '',
    webviewLink: '',
    description: '',
  })
  const [isShowAlertPopup, setIsShowAlertPopup] = useState(false)
  const [isShowJobInputPopup, setIsShowJobInputPopup] = useState(false)
  const { data: jobStatus } = useCafJobStatus()

  useEffect(() => {
    if (jobStatus == UserJobStatus.SHOW) {
      setIsShowJobInputPopup(false)
      setIsShowAlertPopup(false)
    }
    if (jobStatus == UserJobStatus.REQUIRE_INFO) {
      setIsShowJobInputPopup(true)
    }
    if (jobStatus == UserJobStatus.REQUIRE_LESSON) {
      setIsShowAlertPopup(true)
      setInfo({
        title: t(n_ai_analysis.job_seg_popup.btn1),
        link: urls.student.newPortal.lessons.schedule,
        webviewLink: urls.webview.lessons.schedule,
        description: t(n_ai_analysis.job_seg_popup.body1),
      })
    }
    if (jobStatus == UserJobStatus.REQUIRE_TRIAL) {
      setIsShowAlertPopup(true)
      setInfo({
        title: t(n_ai_analysis.job_seg_popup.btn2),
        link: urls.student.newPortal.trial.inputProfile,
        webviewLink: `${urls.student.newPortal.trial.inputProfile}?app=true`,
        description: t(n_ai_analysis.job_seg_popup.body2),
      })
    }
    if (jobStatus == UserJobStatus.REQUIRE_PURCHASE) {
      setIsShowAlertPopup(true)
      setInfo({
        title: t(n_ai_analysis.job_seg_popup.btn3),
        link: urls.student.newPortal.pricing.index,
        webviewLink: `${urls.student.newPortal.pricing.index}?app=true`,
        description: t(n_ai_analysis.job_seg_popup.body1),
      })
    }
  }, [jobStatus])

  return {
    isShowAlertPopup,
    isShowJobInputPopup,
    info,
    jobStatus,
  }
}

export default useJobAnalysisPopup
